import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  all: 'https://readdy.ai/api/search-image?query=Elegant%20organized%20archive%20of%20media%20collections%20with%20warm%20ambient%20lighting%2C%20sophisticated%20library%20aesthetic%2C%20deep%20red%20and%20gold%20tones%2C%20minimal%20editorial%20photography%2C%20curated%20gallery%20atmosphere&width=600&height=400&seq=cat-all&orientation=landscape',
  latest: 'https://readdy.ai/api/search-image?query=Modern%20premium%20cinema%20experience%20with%20state%20of%20the%20art%20projection%2C%20warm%20crimson%20ambient%20lighting%2C%20sophisticated%20entertainment%20technology%2C%20editorial%20photography%2C%20luxurious%20atmosphere&width=600&height=400&seq=cat-latest&orientation=landscape',
  masterpiece: 'https://readdy.ai/api/search-image?query=Classic%20vintage%20film%20awards%20display%20with%20golden%20trophies%20on%20elegant%20pedestal%2C%20dramatic%20spotlight%2C%20theater%20velvet%20curtain%20background%2C%20deep%20red%20and%20gold%20tones%2C%20prestigious%20artistic%20composition&width=600&height=400&seq=cat-masterpiece&orientation=landscape',
  'photo-book': 'https://readdy.ai/api/search-image?query=Artistic%20photography%20portfolio%20display%20with%20premium%20photo%20prints%20on%20minimal%20gallery%20wall%2C%20soft%20natural%20lighting%2C%20sophisticated%20editorial%20aesthetic%2C%20warm%20neutral%20tones%2C%20fine%20art%20quality&width=600&height=400&seq=cat-photo&orientation=landscape',
  'fan-news': 'https://readdy.ai/api/search-image?query=Warm%20intimate%20community%20gathering%20space%20with%20soft%20decorative%20lighting%2C%20cozy%20atmosphere%2C%20elegant%20floral%20arrangements%2C%20premium%20event%20venue%2C%20deep%20crimson%20and%20gold%20accents%2C%20editorial%20photography&width=600&height=400&seq=cat-fan&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">按类别探索大桥未久的精彩世界</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden h-40 md:h-48 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <div className="flex items-center gap-2 text-white mb-1">
                  <i className={`${cat.icon} text-lg`}></i>
                  <span className="text-sm md:text-base font-heading font-semibold">{cat.name}</span>
                </div>
                <p className="text-xs text-white/70 hidden md:block">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}